<app-page-container>
    <app-narrow-wrap>
        <div class="account-exist-content" [innerHtml]="('REGISTER_ACCOUNT_EXISTS_TEXT' | translate)" appAnchorClick (anchorClicked)="login()" (keyup.enter)="login()"></div>
    </app-narrow-wrap>
</app-page-container>
